const axios = require("axios");
const defaultTimeout = 60000;
const extendedTimeout = 300000;
const extendedTimeoutApps = ["pflegegrad"];
axios.defaults.timeout = defaultTimeout;

const BASE_API_URL = `${
  process.env.VUE_APP_NODE_ENVIRONMENT === "development"
    ? "http://localhost:3070"
    : ""
}/api`;

export async function evaluateAnswer(data) {
  console.log("=== THIS IS BEING SENT TO THE BACKEND ===");
  console.log(data);

  // set specific timeout based on application
  let requestSpecificTimeout = defaultTimeout;
  if (extendedTimeoutApps.includes(data.flowState.application)) {
    requestSpecificTimeout = extendedTimeout;
  }

  const response = await axios.post(
    `${BASE_API_URL}/v1/dialog`,
    { data },
    { timeout: requestSpecificTimeout }
  );

  console.log("=== AND THIS IS THE RESPONSE FROM THE BACKEND ===");
  console.log(response.data);
  return response.data;
}

export async function reportBugToBackend(bugDescription, logs) {
  console.log("=== BUG REPORT TO THE BACKEND ===");
  let data = {
    bugDescription: bugDescription,
    logs: logs,
  };

  console.log(data);

  const response = await axios.post(`${BASE_API_URL}/userFeedback/bug`, {
    data,
  });

  console.log("=== BUG RESPONSE FROM THE BACKEND ===");
  console.log(response.data);
  return response.data;
}

export async function addMailToNewsletter(newsletterEmail, interestedTopic) {
  console.log("=== NEWSLETTER REPORT TO THE BACKEND ===");
  let data = {
    newsletterEmail: newsletterEmail,
    interestedTopic: interestedTopic,
  };
  console.log(data);

  const response = await axios.post(`${BASE_API_URL}/subscribeToNewsletter`, {
    data,
  });

  console.log("=== NEWSLETTER RESPONSE FROM THE BACKEND ===");
  console.log(response.data);
  return response.data;
}

export async function recordInterestInTopic(uuid, interestedTopic) {
  console.log("=== RECORD INTEREST IN TOPIC REPORT TO THE BACKEND ===");
  let data = {
    uuid: uuid,
    interestedTopic: interestedTopic,
  };
  console.log(data);

  const response = await axios.post(`${BASE_API_URL}/recordInterestInTopic`, {
    data,
  });

  console.log("=== RECORD INTEREST IN TOPIC RESPONSE FROM THE BACKEND ===");
  console.log(response.data);
  return response.data;
}

export async function recordInteractionForSession(uuid, eventType, eventData) {
  console.log("=== RECORD INTERACTION FOR SESSION IN THE BACKEND ===");
  let data = {
    uuid: uuid,
    eventType: eventType,
    eventData: eventData,
  };
  console.log(data);

  const response = await axios.post(
    `${BASE_API_URL}/recordInteractionForSession`,
    {
      data,
    }
  );

  console.log(
    "=== GOT RESPONSE FOR RECORD INTERACTION FOR SESSION FROM THE BACKEND ==="
  );
  console.log(response.data);
  return response.data;
}

export async function initiateLoggingSession(
  browserInformation,
  contextInformation,
  requestInformation
) {
  console.log("=== GENERATION OF SESSION IN THE BACKEND ===");
  let data = {
    browserInformation: browserInformation,
    contextInformation: contextInformation,
    requestInformation: requestInformation,
  };
  console.log(data);

  const response = await axios.post(`${BASE_API_URL}/generateLoggingSession`, {
    data,
  });

  console.log(
    "=== GOT RESPONSE FOR GENERATION OF SESSION FROM THE BACKEND ==="
  );
  console.log(response.data);
  return response.data;
}

export async function getInfoFromBackend() {
  const response = await axios.get(`${BASE_API_URL}/info`);

  console.log("=== INFO RESPONSE FROM THE BACKEND ===");
  console.log(response.data);
  return response.data;
}

export async function reportNewTopicToBackend(topic) {
  console.log("=== TOPIC REPORT TO THE BACKEND ===");
  let data = {
    topic: topic,
  };
  const response = await axios.post(`${BASE_API_URL}/userFeedback/topic`, {
    data,
  });

  console.log("=== TOPIC RESPONSE FROM THE BACKEND ===");
  console.log(response.data);
  return response.data;
}

export async function getStartPageInfo() {
  console.log("=== GET STARTPAGE INFO ===");
  const response = await axios.get(`${BASE_API_URL}/v1/startpage`);
  console.log("=== STARTPAGE INFO RESPONSE FROM THE BACKEND ===");
  console.log(response.data);
  return response.data;
}

export async function getSearchSuggestions(searchBarEntry) {
  console.log("=== GET SUGGEST FOR SEARCH ===");
  const params = {
    t: searchBarEntry,
  };
  const response = await axios.get(`${BASE_API_URL}/v1/suggest`, { params });
  console.log("=== SUGGEST RESPONSE FROM THE BACKEND ===");
  console.log(response.data);
  return response.data;
}

export async function getSearchPrdSuggestions(searchBarEntry) {
  console.log("=== GET PRODUCT SUGGEST FOR SEARCH ===");
  const params = {
    t: searchBarEntry,
  };
  const response = await axios.get(`${BASE_API_URL}/v1/prdSuggest`, { params });
  console.log("=== PRODUCT SUGGEST RESPONSE FROM THE BACKEND ===");
  console.log(response.data);
  return response.data;
}

export async function getSearchInsuSuggestions(searchBarEntry) {
  console.log("=== GET INSURANCE SUGGEST FOR SEARCH ===");
  const params = {
    t: searchBarEntry,
  };
  const response = await axios.get(`${BASE_API_URL}/v1/insuSuggest`, {
    params,
  });
  console.log("=== PRODUCT INSURANCE RESPONSE FROM THE BACKEND ===");
  console.log(response.data);
  return response.data;
}

export async function getSearchLocationSuggestions(searchBarEntry) {
  console.log("=== GET LOCATION SUGGEST FOR SEARCH ===");
  const params = {
    t: searchBarEntry,
  };
  const response = await axios.get(`${BASE_API_URL}/v1/locationSuggest`, {
    params,
  });
  console.log("=== PRODUCT LOCATION RESPONSE FROM THE BACKEND ===");
  console.log(response.data);
  return response.data;
}

export async function getCurLocationSuggestion(searchBarEntry) {
  const params = {
    t: searchBarEntry,
  };
  const response = await axios.get(`${BASE_API_URL}/v1/curlocationSuggest`, {
    params,
  });
  return response.data;
}

export async function getCurLatlon(searchBarEntry) {
  console.log("=== GET CURRENT LATLON ===", searchBarEntry);
  const params = {
    t: searchBarEntry,
  };
  const response = await axios.get(`${BASE_API_URL}/v1/curLatlon`, { params });
  console.log("=== GET CURRENT LATLON RESPONSE===", response.data);
  return response.data;
}

export async function createNewOrder(params) {
  let url = `${BASE_API_URL}/v1/orders/createOrder`;
  const data = { ...params, meta: { origin: "b2c_appointmentBooking" } };
  const response = await axios.post(url, { params: data });
  return response.data;
}

export async function addFileIdsOrder(params) {
  const response = await axios.post(
    `${BASE_API_URL}/v1/orders/addDocumentIDsToOrder`,
    {
      params,
    }
  );
  return response.data;
}

export async function createNewBook(params) {
  const response = await axios.post(`${BASE_API_URL}/v1/stores/createBooking`, {
    params,
  });
  return response.data;
}

export async function getBookingOption(params) {
  const response = await axios.get(`${BASE_API_URL}/v1/stores/bookingOptions`, {
    params,
  });
  return response.data;
}

export async function getBookingAvailability(params) {
  const response = await axios.get(
    `${BASE_API_URL}/v1/stores/bookingAvailability`,
    {
      params,
    }
  );
  return response.data;
}

export async function getProductSearchByTerm(searchTerm) {
  console.log("=== GET PRODUCTS FOR SEARCH BY TERM ===");
  console.log(searchTerm);
  const params = {
    t: searchTerm,
  };
  const response = await axios.get(`${BASE_API_URL}/v1/prdSuggest`, { params });
  console.log("=== SEARCH BY TERM RESPONSE FROM THE BACKEND ===");
  console.log(response.data);
  return response.data;
}

export async function getProductSearchByID(searchID) {
  console.log("=== GET PRODUCTS FOR SEARCH BY ID ===");
  const params = {
    id: searchID,
  };
  const response = await axios.get(`${BASE_API_URL}/v1/search`, { params });
  console.log("=== SEARCH BY ID RESPONSE FROM THE BACKEND ===");
  console.log(response.data);
  return response.data;
}

export async function getStores(criteria) {
  let params = {};
  if (criteria.showAllStores) {
    params = {
      chainFilter: criteria.chainFilter,
      showAllStores: criteria.showAllStores,
    };
  } else {
    if (
      criteria.insuranceID === "" ||
      typeof criteria.insuranceID === "undefined"
    ) {
      params = {
        gPlaceID: criteria.placeID,
        products: criteria.products,
        chainFilter: criteria.chainFilter,
      };
    } else {
      params = {
        gPlaceID: criteria.placeID,
        products: criteria.products,
        insuranceID: criteria.insuranceID,
        chainFilter: criteria.chainFilter,
      };
    }
  }
  let url = `${BASE_API_URL}/v1/stores`;
  return axios
    .get(url, { params })
    .then((response) => {
      console.log("stores", response.data);
      return response.data;
    })
    .catch((error) => {
      console.log("get stores error", error);
    });
}

export async function getStoreDetail(storeMeta) {
  const params = {
    storeID: storeMeta.storeID,
    dataSrc: storeMeta.dataSrc,
    quickView: storeMeta.quickView,
  };
  const response = await axios.get(`${BASE_API_URL}/v1/stores/details`, {
    params,
  });
  console.log("store detail", response.data);
  return response.data;
}

export async function generatePDF(prdIDs) {
  console.log("prdIDs", prdIDs);
  const params = {
    productIDs: prdIDs,
  };
  const response = await axios.get(`${BASE_API_URL}/v1/downloadPDF`, {
    responseType: "blob",
    params: params,
  });
  return response;
}

export async function uploadPrescriptions(files) {
  const response = await axios.post(
    `${BASE_API_URL}/v1/uploadPrescriptions`,
    files
  );
  console.log("files upload result", response.data);
  return response.data;
}

export async function getSEOIDForProduct(productID) {
  console.log("=== GET SEO ID FOR PRODUCT ===");
  const params = {
    id: productID,
  };
  const response = await axios.get(`${BASE_API_URL}/v1/seoIDLookup`, {
    params,
  });
  console.log("=== GET SEO ID FOR PRODUCT RESPONSE ===");
  console.log(response.data);
  return response.data;
}

export async function getProductSearchByTag(tagType, tagCanonical) {
  console.log("=== GET PRODUCTS FOR SEARCH BY TAG ===");
  const params = {
    tagType: tagType,
    tagCanonical: tagCanonical,
  };
  const response = await axios.get(`${BASE_API_URL}/v1/search`, { params });
  console.log("=== SEARCH BY TAG RESPONSE FROM THE BACKEND ===");
  console.log(response.data);
  return response.data;
}

export async function getProductDBContentForProductID(productIDArray) {
  console.log("=== GET PRODUCT DB CONTENT FOR PRODUCT ID ARRAY ===");
  const params = {
    productIDs: productIDArray.join(","),
  };
  const response = await axios.get(
    `${BASE_API_URL}/v1/retrieveProductsFromDB`,
    {
      params,
    }
  );
  console.log(
    "=== PRODUCT DB CONTENT FOR PRODUCT ID ARRAY RESPONSE FROM THE BACKEND ==="
  );
  console.log(response.data);
  return response.data;
}
